import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemTypeListComponent } from './components/item-type-list/item-type-list.component';
import { ItemTypeEditComponent } from './components/item-type-edit/item-type-edit.component';
import { RouterModule } from '@angular/router';
import {moduleRoutes} from './module.routes';
import { MatNativeDateModule,
  MatChipsModule, MatButtonToggleModule, MatPaginator, MatPaginatorModule, MatPaginatorIntl,
  MatSlideToggle, MatSlideToggleModule, MatSortModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ItemListComponent } from './components/item-list/item-list.component';
import { ItemEditComponent } from './components/item-edit/item-edit.component';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS, OwlDateTimeIntl} from 'ng-pick-datetime';
import { DATETIME_FORMATS } from './config/date-time.formats';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ColorPickerModule } from 'ngx-color-picker';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PaginatorI18n } from '../shared/translator/PaginatorI18n';
import { SharedModule } from '../shared/shared.module';
import { DDDateAdapter } from '../shared/adapters/DDDateAdapter';
import { ItemDashboardComponent } from './components/item-dashboard/item-dashboard.component';
import { ScheduleListComponent } from './components/schedule-list/schedule-list.component';
import { ScheduleEditComponent } from './components/schedule-edit/schedule-edit.component';
import { UserStatusComponent } from './components/user-status/user-status.component';
import { DateTimeTranslations } from './config/date-time.translations';
import { DateAdapter } from '@angular/material/core';
import { NgxMatDateAdapter } from '@angular-material-components/datetime-picker';

import {
  NgxMatDatetimePickerModule, 
  NgxMatNativeDateModule, 
  NgxMatTimepickerModule,
  NGX_MAT_DATE_FORMATS 
} from '@angular-material-components/datetime-picker';

@NgModule({
  declarations: [
    ItemTypeListComponent,
    ItemTypeEditComponent,
    ItemListComponent,
    ItemEditComponent,
    DateTimePickerComponent,
    ItemDashboardComponent,
    ScheduleListComponent,
    ScheduleEditComponent,
    UserStatusComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatIconModule,
    MatMenuModule,
    MatGridListModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatTableModule,
    MatChipsModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatDialogModule,
    MatTooltipModule,
    MatTabsModule,
    MatSortModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    NgxMaterialTimepickerModule,
    NgxMatSelectSearchModule,
    MatPaginatorModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    FlexLayoutModule,
    ColorPickerModule,
    SharedModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,    
    RouterModule.forChild(moduleRoutes),
    TranslateModule,
  ],
  providers: [
    // { provide: NGX_MAT_DATE_FORMATS, useValue: DD_DATE_FORMATS },        
    {provide: OwlDateTimeIntl, useClass: DateTimeTranslations},
    {
      provide: MatPaginatorIntl, deps: [TranslateService],
      useFactory: (translateService: TranslateService) => new PaginatorI18n(translateService).getPaginatorIntl()
    },
    { provide: NgxMatDateAdapter, useClass: DDDateAdapter},
    { provide: DateAdapter, useClass: DDDateAdapter}
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class TimeTrackingModule { }
